import React from 'react';

/**
 * Modern segmented "pill" tab bar. Active tab is a white pill with a soft shadow;
 * inactive tabs are muted. Matches the app's soft, rounded aesthetic.
 *
 * @param {{ tabs: Array<{id:string,label:string,icon?:any,count?:number}>, active:string, onChange:(id:string)=>void, size?:'sm'|'md', className?:string }} props
 */
export default function PillTabs({ tabs, active, onChange, size = 'md', className = '' }) {
  const pad = size === 'sm' ? 'px-3 py-1.5 text-xs' : 'px-4 py-2 text-sm';
  return (
    <div className={`inline-flex max-w-full flex-wrap items-center gap-1 rounded-xl bg-gray-100/80 p-1 ${className}`}>
      {tabs.map((t) => {
        const isActive = active === t.id;
        const Icon = t.icon;
        return (
          <button
            key={t.id}
            type="button"
            onClick={() => onChange(t.id)}
            title={t.label}
            className={`inline-flex items-center gap-1.5 whitespace-nowrap rounded-lg font-medium transition-all duration-150 ${pad} ${
              isActive
                ? 'bg-white text-primary-700 shadow-sm ring-1 ring-black/[0.03]'
                : 'text-gray-500 hover:bg-white/60 hover:text-gray-800'
            }`}
          >
            {Icon && <Icon className={size === 'sm' ? 'h-3.5 w-3.5' : 'h-4 w-4'} />}
            {t.label}
            {t.count != null && (
              <span className={`ml-0.5 rounded-full px-1.5 text-[11px] font-semibold ${isActive ? 'bg-primary-50 text-primary-700' : 'bg-gray-200 text-gray-600'}`}>
                {t.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
